module.exports = __webpack_public_path__ + "img/user-white.d5bf079.png";